import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUsersFiltered = createSelector(
  [(store: RootState) => store.users.users, (store: RootState) => store.users.searchText],
  (users, searchText) => {
    searchText = (searchText || "").toLowerCase();
    return users.filter((item) => {
      return item.nameNormalized?.toLowerCase().includes(searchText);
    });
  }
);
